import globalApiLocation from "../core/api/globalApiLocation";
import { useEffect } from "react";

export function useGoogleRedirect(redirect_url: string, useClientId: boolean, invitationId?: string) {
  let base = `${globalApiLocation()}/authenticate/google`;
  const loginUri = useClientId
    ? `${base}/callback/`
    : `${base}/redirect/?redirect_uri=${encodeURIComponent(redirect_url)}`;

  const invitationUri =
    useClientId && invitationId != null
      ? `${globalApiLocation()}/user-invitation/google/callback/`
      : null;

  useEffect(() => {
    const id = "googlesso";
    if (!document.getElementById(id)) {
      const script: HTMLScriptElement = document.createElement("script");
      script.id = "googlesso";
      document.head.appendChild(script);
      script.src = "https://accounts.google.com/gsi/client";

      return () => {
        document.head.removeChild(script);
      };
    }
  }, []);

  const state = useClientId
    ? btoa(JSON.stringify({ client: "classic", ...(invitationId && { id: invitationId }) }))
    : undefined;

  return { loginUri, invitationUri, state };
}
